export default {
  apiURL: import.meta.env.VITE_API_URL,
};
